import store from '@/store';
import auth from '@/common/auth/auth';
import BADGES_COLOR_MAP from '@/data/badges-color-map';
import _ from '@/common/helpers';

export default {
    store,
    version: 11,
    defaultColumns: [
        {
            name: 'id',
            sortable: true,
            type: 'link',
            to: ({fields}) => ({
                name: 'order-upcoming-invoice',
                params: {
                    id: fields.id,
                },
            }),
            predicate: auth.$pages['order-upcoming-invoice'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            style: {truncate: true},
            sticky: true,
        },
        {
            header: 'Customer',
            name: 'customerId',
            sortable: true,
            type: 'link',
            value: fields => _.getIdentifier({concat: ['firstName', 'lastName']})(fields._embedded.customer),
            to: ({fields}) => ({
                name: 'customer-details',
                params: {
                    id: fields.customerId,
                },
            }),
            predicate: auth.$pages['customer-details'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            expand: 'customer',
        },
        {
            header: 'Customer Email',
            sortable: false,
            name: 'customer.email',
            expand: 'customer',
        },
        {
            header: 'Website Id',
            name: 'websiteId',
            sortable: true,
        },
        {
            header: 'Type',
            name: 'orderType',
            value: (fields) => {
                if (fields.orderType === 'subscription-order') {
                    return 'Subscription';
                }
                return 'One-Time';
            },
            sortable: true,
        },
        {
            header: 'Start Time',
            name: 'startTime',
            type: 'datetime',
            sortable: true,
        },
        {
            header: 'Renewal Time',
            name: 'renewalTime',
            type: 'datetime',
            sortable: true,
        },
        {
            header: 'Cancellation Time',
            name: 'canceledTime',
            type: 'datetime',
            sortable: true,
        },
        {
            header: 'Plan Id',
            name: 'planId',
            value: fields => fields.items.map(item => item.planId),
        },
        {
            header: 'Quantity',
            name: 'quantity',
            value: fields => fields.items.map(item => item.quantity),
        },
    ],
    otherColumns: [
        {
            header: 'Delivery Address First Name',
            name: 'deliveryAddress.firstName',
        },
        {
            header: 'Delivery Address Last Name',
            name: 'deliveryAddress.lastName',
        },
        {
            header: 'Delivery Address Organization',
            name: 'deliveryAddress.organization',
        },
        {
            header: 'Delivery Address',
            name: 'deliveryAddress.address',
        },
        {
            header: 'Delivery Address2',
            name: 'deliveryAddress.address2',
        },
        {
            header: 'Delivery Address City',
            name: 'deliveryAddress.city',
        },
        {
            header: 'Delivery Address Region',
            name: 'deliveryAddress.region',
        },
        {
            header: 'Delivery Address Country',
            name: 'deliveryAddress.country',
        },
        {
            header: 'Delivery Address Postal Code',
            name: 'deliveryAddress.postalCode',
        },
        {
            header: 'Delivery Address Phone Numbers',
            name: 'deliveryAddress.phoneNumbers',
            type: 'complex',
            map: v => v.value,
        },
        {
            header: 'Delivery Address Emails',
            name: 'deliveryAddress.emails',
            type: 'complex',
            map: v => v.value,
        },
        {
            header: 'Billing Address First Name',
            name: 'billingAddress.firstName',
        },
        {
            header: 'Billing Address Last Name',
            name: 'billingAddress.lastName',
        },
        {
            header: 'Billing Address Organization',
            name: 'billingAddress.organization',
        },
        {
            header: 'Billing Address',
            name: 'billingAddress.address',
        },
        {
            header: 'Billing Address2',
            name: 'billingAddress.address2',
        },
        {
            header: 'Billing Address City',
            name: 'billingAddress.city',
        },
        {
            header: 'Billing Address Region',
            name: 'billingAddress.region',
        },
        {
            header: 'Billing Address Country',
            name: 'billingAddress.country',
        },
        {
            header: 'Billing Address Postal Code',
            name: 'billingAddress.postalCode',
        },
        {
            header: 'Billing Address Phone Numbers',
            name: 'billingAddress.phoneNumbers',
            type: 'complex',
            map: v => v.value,
        },
        {
            header: 'Billing Address Emails',
            name: 'billingAddress.emails',
            type: 'complex',
            map: v => v.value,
        },
        {
            header: 'Risk Metadata Ip Address',
            name: 'riskMetadata.ipAddress',
        },
        {
            header: 'Risk Metadata Is Proxy',
            name: 'riskMetadata.isProxy',
        },
        {
            header: 'Risk Metadata Is Vpn',
            name: 'riskMetadata.isVpn',
        },
        {
            header: 'Risk Metadata Is Tor',
            name: 'riskMetadata.isTor',
        },
        {
            header: 'Risk Metadata Is Hosting',
            name: 'riskMetadata.isHosting',
        },
        {
            header: 'Risk Metadata Vpn Service Name',
            name: 'riskMetadata.vpnServiceName',
        },
        {
            header: 'Risk Metadata Isp',
            name: 'riskMetadata.isp',
        },
        {
            header: 'Risk Metadata Country',
            name: 'riskMetadata.country',
        },
        {
            header: 'Risk Metadata Latitude',
            name: 'riskMetadata.latitude',
        },
        {
            header: 'Risk Metadata Longitude',
            name: 'riskMetadata.longitude',
        },
        {
            header: 'Risk Metadata Postal Code',
            name: 'riskMetadata.postalCode',
        },
        {
            header: 'Risk Metadata Time Zone',
            name: 'riskMetadata.timeZone',
        },
        {
            header: 'Risk Metadata Accuracy Radius',
            name: 'riskMetadata.accuracyRadius',
        },
        {
            header: 'Risk Metadata Fingerprint',
            name: 'riskMetadata.fingerprint',
        },
        {
            header: 'Risk Metadata Http Headers',
            name: 'riskMetadata.httpHeaders',
        },
        {
            header: 'Risk Metadata Distance',
            name: 'riskMetadata.distance',
        },
        {
            header: 'Risk Metadata Score',
            name: 'riskMetadata.score',
        },
        {
            name: 'initialInvoiceId',
        },
        {
            name: 'status',
            type: 'badge',
            map: BADGES_COLOR_MAP.orderStatus,
        },
        {
            name: 'billingStatus',
            type: 'badge',
            map: BADGES_COLOR_MAP.orderBillingStatus,
        },
        {
            name: 'autopay',
        },
        {
            name: 'inTrial',
        },
        {
            name: 'rebillNumber',
        },
        {
            name: 'canceledBy',
        },
        {
            name: 'cancelDescription',
        },
        {
            header: 'Activation Time',
            name: 'activationTime',
            type: 'datetime',
            sortable: true,
        },
        {
            header: 'End Time',
            name: 'endTime',
            type: 'datetime',
            sortable: true,
        },
        {
            header: 'Creation Time',
            name: 'createdTime',
            type: 'datetime',
            sortable: true,
        },
        {
            header: 'Last Update Time',
            name: 'updatedTime',
            type: 'datetime',
            sortable: true,
        },
        // lead source
        {
            name: 'leadSource.campaign',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.medium',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.source',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.term',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.content',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.affiliate',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.subAffiliate',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.salesAgent',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.amount',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.path',
            expand: 'leadSource',
        },
    ],
};
